import { html } from '@polymer/polymer/polymer-element.js';
import { KatapultWidget } from './katapult-widget';
import Chart from 'chart.js/auto';

class MeetingWidget extends KatapultWidget {
  static get widgetTitleTemplate() {
    return html`<span> Meeting Spaces </span>`;
  }

  static get bodyTemplate() {
    return html`
      <style is="custom-style">
        .flex-container {
          display: flex;
          flex-direction: row;
          flex-wrap: nowrap;
          justify-content: center;
          align-content: center;
          align-items: flex-start;
        }
        paper-table {
          order: 0;
          flex: 0 1 auto;
          align-self: auto;
          margin: 1em;
        }
        paper-row {
          height: 20%;
          min-width: 20%;
          border-bottom: solid #e8e8e8 thin;
          padding-top: 1em;
          padding-bottom: 1em;
        }
        paper-cell {
          font-size: 1.2em;
          width: 30%;
        }
        .middle {
          border-left: solid #e8e8e8 thin;
          border-right: solid #e8e8e8 thin;
        }
        .bottom {
          border-bottom-left-radius: 10px;
          border-bottom-right-radius: 10px;
        }
        #header {
          height: 3em;
          font-weight: bold;
          background-color: #e8e8e8;
          border-top-left-radius: 10px;
          border-top-right-radius: 10px;
          align-content: center;
        }
        material-icon {
          margin-right: 0.5em;
          color: green;
        }
        .occupied {
          color: red;
        }
      </style>
      <div class="flex-container">
        <paper-table>
          <paper-row id="header">
            <paper-cell>19 N</paper-cell>
          </paper-row>
          <paper-row class="middle">
            <paper-cell>
              <material-icon icon="circle" id="lobby_19"> </material-icon>
              Lobby
            </paper-cell>
          </paper-row>
          <paper-row class="middle">
            <paper-cell>
              <material-icon icon="circle" id="conference_19"> </material-icon>
              Conference Room
            </paper-cell>
          </paper-row>
          <paper-row class="middle bottom">
            <paper-cell>
              <material-icon icon="circle" id="attic_19"> </material-icon>
              The Attic
            </paper-cell>
          </paper-row>
        </paper-table>

        <paper-table>
          <paper-row id="header">
            <paper-cell>13 S</paper-cell>
          </paper-row>
          <paper-row class="middle">
            <paper-cell>
              <material-icon icon="circle" id="lobby_13"> </material-icon>
              Lobby
            </paper-cell>
          </paper-row>
          <paper-row class="middle">
            <paper-cell>
              <material-icon icon="circle" id="conference_room_13"> </material-icon>
              Conference Table
            </paper-cell>
          </paper-row>
          <paper-row class="middle bottom">
            <paper-cell>
              <material-icon icon="circle" id="downstairs_table13"> </material-icon>
              Downstairs Table
            </paper-cell>
          </paper-row>
        </paper-table>

        <paper-table>
          <paper-row id="header">
            <paper-cell>Lab</paper-cell>
          </paper-row>
          <paper-row class="middle">
            <paper-cell>
              <material-icon icon="circle" id="lab_lobby"> </material-icon>
              Lobby
            </paper-cell>
          </paper-row>
          <paper-row class="middle bottom">
            <paper-cell>
              <material-icon icon="circle" id="back_room"> </material-icon>
              Back Table
            </paper-cell>
          </paper-row>
        </paper-table>
      </div>
    `;
  }

  static get properties() {
    return {
      paperHeader: {
        type: Boolean,
        value: false // default is false
      },
      cycleTotals: {
        type: Array,
        computed: 'getCycleTotals(userTimesheets.*, displayWeekStart)',
        observer: 'updatePieChart'
      }
    };
  }

  //  initPieChart() {
  //   // Try to get the pie chart element (returning false if we cannot)
  //   let pieChartElement = this.shadowRoot.querySelector(`#cycleTotalsPieChart`);
  //   if (!pieChartElement) return false;

  //   // Initialize the pie chart
  //   this.pieChart = new Chart(pieChartElement.getContext('2d'), {
  //     type: 'pie',
  //     data: {},
  //     options: {
  //       plugins: {
  //         legend: { display: false },
  //         tooltip: { displayColors: false }
  //       },
  //       layout: { padding: 12 }
  //     }
  //   });
  //   // True for success
  //   return true;
  //  }

  ready() {
    super.ready();
    this.getDatabase();
  }

  async getDatabase() {
    // Read
    await firebase
      .database()
      .ref(`/photoheight/home/meeting_room_widget/`)
      .on('value', (snap) => {
        let rooms = snap.val();
        for (let buildingData of Object.values(rooms)) {
          for (const [room, occupied] of Object.entries(buildingData)) {
            this.changeStyle(room, occupied || false);
          }
        }
      });
  }

  changeStyle(room, occupied) {
    // if the room exists (there's a matching element id for the current database value), set its occupency color
    if (this.shadowRoot.querySelector('#' + room)) {
      if (occupied == true) this.shadowRoot.querySelector('#' + room).className = 'occupied';
      else this.shadowRoot.querySelector('#' + room).className = null;
    }
  }
}
window.customElements.define('meeting-widget', MeetingWidget);
